import { combineEpics } from 'redux-observable';
import { addConvocation, searchQueryConvocation, updateConvocation } from './convocation.epics';

export const rootConvocationEpics = combineEpics(
  searchQueryConvocation,
  addConvocation,
  updateConvocation,
);
